import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { ComponentsConfig } from '@modules/candidates/components/components.abstract.config';

import { Attachment } from '@shared/models';
import { MojoPrivilegesService } from 'mojo-privileges';

@Component({
  selector: 'mojo-attachments-list',
  templateUrl: './attachments-list.component.html',
  styleUrls: ['./attachments-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentsListComponent {
  @Input()
  attachments: Attachment[];

  @Input()
  emptyMessage: string;

  @Input()
  hideIfEmpty = false;

  @Input()
  title: string;

  @Output()
  delete: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  upload: EventEmitter<void> = new EventEmitter<void>();

  filesReadOnly$ = this.privilegeService.hasPrivilege(
    this.componentsConfig.privileges.candidates.filesReadOnly,
  );

  constructor(
    private cdf: ChangeDetectorRef,
    private privilegeService: MojoPrivilegesService,
    private componentsConfig: ComponentsConfig,
  ) {}

  menuOpened() {
    this.cdf.markForCheck();
  }

  menuClosed() {
    this.cdf.markForCheck();
  }
}
